import axios from "axios";
import { DASHBOARD_FETCH } from "../config/urlConfig";

export async function getDashboardDetails(token){
    try{
      try {
    
        let response = await axios.get(`${DASHBOARD_FETCH}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
  
    
        return response.data;
      } catch (error) {
        if (error?.response) {
          console.log(error.response.data);
    
          return error.response.data;
        }
        console.log(error.message);
      }
    }catch(error){
      console.log("err", error.message);
      
    }
  }
  